import { Injectable } from "@angular/core";
import { Actions, concatLatestFrom, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { TelemetryService } from "@obg/ngx.global";
import { RouteSelector } from "@obg/ngx.router";
import { filter, tap } from "rxjs/operators";

import { AUTH_TRANSACTION_ACTION_TYPE } from "../../auth-transaction/auth-transaction.action";
import { CORE_ROUTE } from "../../route";
import { CoreState } from "../../state";
import { AuthTelemetryEventName, LoginMethod } from "../auth/auth-telemetry.model";

@Injectable()
export class AuthTransactionTelemetryEffect {
	initializeAuthTransaction$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransaction),
				concatLatestFrom(() => this.store.select(RouteSelector.getCurrent)),
				filter(([, current]) => current?.name !== CORE_ROUTE.registration.register),
				tap(() => {
					this.service.track({
						event: AuthTelemetryEventName.LoginSubmitted,
						LoginMethod: LoginMethod.BankId,
					});
				})
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private service: TelemetryService,
		private store: Store<CoreState>
	) {}
}
